const downloadAsBlob = (bites, headers, nombreArchivo = '') => {
  let fileName = ''
  const disposition = headers['content-disposition']
  
  if (disposition && disposition.indexOf('attachment') !== -1) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    var matches = filenameRegex.exec(disposition)
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '')
    }
  }

  const linkSource = window.URL.createObjectURL(new Blob([bites]))
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName || nombreArchivo
  document.body.appendChild(downloadLink)
  downloadLink.click()
}

export default Object.freeze({ downloadAsBlob })
